import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "reactstrap";
import { useAuthContext } from "../../../auth/useAuthContext";
import Loading from "../../../common/Loading";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Icon } from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { fetchOrders } from "../../../redux/slices/orderSlice";
import KanbanBoard from "./KanbanBoard";

const NewOrders = () => {
  const { user } = useAuthContext();
  const dispatch = useDispatch();
  const [dragged, setDragged] = useState(false);
  const [onSearchText, setSearchText] = useState(null);
  const [onSearch, setonSearch] = useState(true);

  const paidOrders = useSelector((state) => state.order.paidOrders);
  
  const invoicedOrders = useSelector((state) => state.order.invoicedOrders);
  console.log("invoiced",invoicedOrders);
   console.log("Paid",paidOrders);
  const newOrders = useSelector((state) => state.order.newOrders);
  
  const fetchLoading = useSelector((state) => state.order.fetchLoading);

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  useEffect(() => {
    if (onSearchText === "" || onSearchText === null) {
      dispatch(
        fetchOrders({
          params: {
            hasInvoice: false,
            ...(user?.role?.slug === "consultant" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
          status: "new",
        })
      );

      dispatch(
        fetchOrders({
          params: {
            status: "invoiced",
            ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
        })
      );

      dispatch(
        fetchOrders({
          params: {
            status: "paid",
            ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
        })
      );
    }
  }, [dispatch, onSearchText, user?.id, user?.role?.slug, dragged]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (onSearchText !== null) {
        dispatch(
          fetchOrders({
            params: {
              hasInvoice: false,
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 1000,
            page: 1,
            status: "new",
          })
        );

        dispatch(
          fetchOrders({
            params: {
              status: "invoiced",
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 1000,
            page: 1,
          })
        );

        dispatch(
          fetchOrders({
            params: {
              status: "paid",
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 1000,
            page: 1,
          })
        );
      }
    }, 3000);
    return () => clearTimeout(debounceTimer);
  }, [dispatch, onSearchText, user?.id, user?.role?.slug, dragged]);

  // useEffect(() => {
  //   dispatch(
  //     fetchOrders({
  //       params: {
  //         hasInvoice: false,
  //         ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
  //       },
  //       limit: 100,
  //       page: 1,
  //       status: "new",
  //     })
  //   );

  //   dispatch(
  //     fetchOrders({
  //       params: {
  //         status: "invoiced",
  //         ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
  //       },
  //       limit: 100,
  //       page: 1,
  //     })
  //   );

  //   dispatch(
  //     fetchOrders({
  //       params: {
  //         status: "paid",
  //         ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
  //       },
  //       limit: 100,
  //       page: 1,
  //     })
  //   );
  // }, [dispatch, dragged, user?.id, user?.role?.slug]);

  const columns = {
    columns: {
      "column-new-order": {
        id: "column-new-order",
        text: "NEW ORDER",
        theme: "light",
        patients: newOrders?.data,
      },
      "column-invoiced": {
        id: "column-invoiced",
        text: "INVOICED",
        theme: "primary",
        patients: invoicedOrders?.data,
      },
      "column-paid": {
        id: "column-paid",
        text: "PAID",
        theme: "warning",
        patients: paidOrders?.data,
      },
    },
    columnOrder: ["column-new-order", "column-invoiced", "column-paid"],
  };

  return (
    <React.Fragment>
      <Head title="New Orders!!"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>New Orders List</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <div className="card-title-group justify-end">
          <div className="card-tools me-n1">
            <ul className="btn-toolbar">
              <li>
                <Button onClick={toggle} className="btn-icon search-toggle toggle-search">
                  <Icon name="search"></Icon>
                </Button>
              </li>
              <li className="btn-toolbar-sep"></li>
            </ul>
          </div>
          <div className={`card-search search-wrap ${!onSearch ? "active" : ""}`}>
            <div className="search-content">
              <Button
                className="search-back btn-icon toggle-search"
                onClick={() => {
                  setSearchText(null);
                  toggle();
                }}
              >
                <Icon name="arrow-left"></Icon>
              </Button>
              <input
                type="text"
                className="form-control border-transparent form-focus-none"
                placeholder="Search by patient or specialist's name, email or phone (after 3 seconds)"
                value={onSearchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
              <Button className="search-submit btn-icon">
                <Icon name="search"></Icon>
              </Button>
            </div>
          </div>
        </div>

        {fetchLoading ? (
          <Loading />
        ) : (
          <Block>
            <div className="nk-kanban">
              <KanbanBoard columns={columns} setDragged={setDragged} />
            </div>
          </Block>
        )}
      </Content>
    </React.Fragment>
  );
};

export default NewOrders;
